import { Component, OnInit, ViewEncapsulation } from "@angular/core";
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { PossessionFamilyMemberDtl } from "src/app/model/PossessionFamilyMemberDtl";
import { UpdatePossessionDtlModel } from "src/app/model/UpdatePossessionDtlModel";
import { PossessionDtlUpdateService } from "src/app/services/possession-dtl-update.service";

@Component({
  selector: "app-secure-update-possession-dtl",
  templateUrl: "./update-possession-dtl.component.html",
  styleUrls: ["./update-possession-dtl.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class UpdatePossessionDtlComponent implements OnInit {
  data: UpdatePossessionDtlModel;
  applicationId: number;
  isLoading: boolean = false;
  form: FormGroup = new FormGroup({});
  submitDisabled: boolean;

  possessionFamilyMemberDtl: PossessionFamilyMemberDtl[];
  afterUpdtPossessionFamilyMemberDtl: PossessionFamilyMemberDtl[];

  selfPhotoSelectedFile: string | ArrayBuffer;
  spousePhotoSelectedFile: string | ArrayBuffer;
  familyPhotoSelectedFile: string | ArrayBuffer;

  selfPhotoError: string;
  spousePhotoError: string;
  familyPhotoError: string;

  famApplicationNo: string;
  isSpouseButtonVisible: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private possessionDtlUpdateService: PossessionDtlUpdateService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.route.params.subscribe((params: Params) => {
      this.applicationId = +params["applicationId"];
      this.isLoading = true;

      this.possessionDtlUpdateService
        .fetchApplicationDetailForPossessionDtlUpdate(this.applicationId)
        .subscribe(
          (data) => {
            this.isLoading = false;
            if (data.status === "SUCCESS") {
              this.data = data;
              this.possessionFamilyMemberDtl = data.possessionFamilyDetailView;
              this.famApplicationNo = data.applicationNo;
              console.log(
                "data.possessionFamilyDetailView",
                data.possessionFamilyDetailView
              );

              if (data.possessionFamilyDetailView) {
                const userResponsibilityLst = this.form.get(
                  "userResponsibilityLst"
                ) as FormArray;

                while (userResponsibilityLst.length !== 0) {
                  userResponsibilityLst.removeAt(0);
                }

                this.possessionFamilyMemberDtl.forEach((familyMember) => {
                  userResponsibilityLst.push(
                    new FormGroup({
                      key: new FormControl(familyMember.key),
                      memberName: new FormControl(
                        familyMember.memberName,
                        Validators.required
                      ),
                      memberAge: new FormControl(
                        familyMember.memberAge,
                        Validators.required
                      ),
                      memberRelation: new FormControl(
                        familyMember.memberRelation,
                        Validators.required
                      ),
                    })
                  );
                });

                // this.generateFormControls(data.possessionFamilyDetailView);
              } else {
                console.error(
                  "possessionFamilyMemberDtl is undefined or null after fetching data"
                );
              }

              if (this.data.maritalStatus === "Married") {
                this.form.addControl("spousePhoto", new FormControl(null));
                this.form.addControl(
                  "spouseEmailId",
                  new FormControl(null, [Validators.required, Validators.email])
                );
              }

              this.form.patchValue({
                emailId: this.data.selfEmailId,
                checkboxFormSpouse:
                  this.data.applicableSpouseName === "Y" ||
                  this.data.applicableSpouseName == null,
              });

              this.onSpouseNameApplicableButton({
                target: {
                  checked:
                    this.data.applicableSpouseName === "Y" ||
                    this.data.applicableSpouseName == null,
                },
              });

              if (this.data.maritalStatus === "Married") {
                this.form.patchValue({
                  spouseEmailId: this.data.spouseEmailId,
                });
              }
            } else {
              this.possessionDtlUpdateService.errorToast(data?.errorMessage);
            }
          },
          (error) => {
            console.log(error);
            this.isLoading = false;
            this.possessionDtlUpdateService.errorToast(
              error?.error?.errorMessage || error?.errorMessage
            );
          }
        );
    });

    this.form = new FormGroup({
      emailId: new FormControl(null, [Validators.required, Validators.email]),
      checkboxFormSpouse: new FormControl("", [Validators.required]),

      userResponsibilityLst: new FormArray([]),
    });
  }

  onSubmit() {
    this.afterUpdtPossessionFamilyMemberDtl = this.getUpdtFamilyMembersArray();

    console.log(
      "this.afterUpdtPossessionFamilyMemberDtl",
      this.afterUpdtPossessionFamilyMemberDtl
    );

    if (this.form.valid) {
      let errorText = "";
      if (!(this.data.selfPhoto || this.selfPhotoSelectedFile)) {
        this.selfPhotoError += "Self Photo is required";
        errorText = "Yes";
      }
      if (
        this.data.maritalStatus === "Married" &&
        !(this.data.spousePhoto || this.spousePhotoSelectedFile)
      ) {
        this.spousePhotoError += "Spouse Photo is required";
        errorText = "Yes";
      }
      if (!(this.data.familyPhoto || this.familyPhotoSelectedFile)) {
        this.familyPhotoError += "Family Photo is required";
        errorText = "Yes";
      }

      if (!errorText) {
        this.submitDisabled = true;
        this.isLoading = true;
        this.possessionDtlUpdateService
          .updatePossessionDetail(this.applicationId, {
            selfPhoto: this.selfPhotoSelectedFile,
            spousePhoto: this.spousePhotoSelectedFile,
            familyPhoto: this.familyPhotoSelectedFile,
            emailId: this.form.value.emailId,
            spouseEmailId: this.form.value.spouseEmailId,
            possessionFamilyMemberDtl: this.possessionFamilyMemberDtl,
            applicableSpouseName: this.isSpouseButtonVisible ? "Y" : "N",
            afterUpdtPossessionFamilyMemberDtl:
              this.afterUpdtPossessionFamilyMemberDtl,
          })
          .subscribe(
            (data: any) => {
              this.submitDisabled = false;
              this.isLoading = false;
              if (data.status === "SUCCESS") {
                this.possessionDtlUpdateService.successToast(
                  "Saved Successfully"
                );
                this.router.navigate([
                  "/secure",
                  "possession-dtl-update",
                  "list",
                ]);
              } else {
                this.submitDisabled = false;
                this.possessionDtlUpdateService.errorToast(data.errorMessage);
              }
            },
            (error) => {
              this.submitDisabled = false;
              this.isLoading = false;
              console.log(error);
              this.possessionDtlUpdateService.errorToast(
                error.error.errorMessage,
                5 * 1000
              );
            }
          );
      } else {
        this.submitDisabled = false;
        this.possessionDtlUpdateService.errorToast(
          "Please enter mandatory fields."
        );
      }
    } else {
      this.submitDisabled = false;
      this.possessionDtlUpdateService.errorToast(
        "Please enter mandatory fields."
      );
    }
  }

  changeFile(type: string) {
    if (type === "SELF") {
      this.data.selfPhoto = null;
    } else if (type === "SPOUSE") {
      this.data.spousePhoto = null;
    } else if (type === "FAMILY") {
      this.data.familyPhoto = null;
    }
  }

  onFileSelect(type, event) {
    this.submitDisabled = true;
    let selectedFile = event.target.files[0];
    const reader = new FileReader();
    reader.readAsDataURL(selectedFile);
    reader.onload = () => {
      if (type === "SELF") {
        this.data.selfPhoto = null;
        this.selfPhotoSelectedFile = reader.result;
      } else if (type === "SPOUSE") {
        this.data.spousePhoto = null;
        this.spousePhotoSelectedFile = reader.result;
      } else if (type === "FAMILY") {
        this.data.familyPhoto = null;
        this.familyPhotoSelectedFile = reader.result;
      }
      this.submitDisabled = false;
    };
  }

  onSpouseNameApplicableButton(e: any) {
    if (e.target) {
      this.isSpouseButtonVisible = e.target.checked;
      console.log("check box ticked for condition", this.isSpouseButtonVisible);
    }
  }

  generateFormControls(possessionFamilyMemberDtl: PossessionFamilyMemberDtl[]) {
    possessionFamilyMemberDtl.forEach((record, index) => {
      const controlName = `dynamicControl${index}`;
      const memberRelation = record.memberRelation;
      const memberName = record.memberName;
      const memberAge = record.memberAge;
      this.form.addControl(`${controlName}_name`, new FormControl(memberName));
      this.form.addControl(`${controlName}_age`, new FormControl(memberAge));
      this.form.addControl(
        `${controlName}_relation`,
        new FormControl(memberRelation)
      );
    });
  }

  validateInput(event: any) {
    var regex = /^[a-zA-Z\s]*$/;
    var searchValue = event.value || event.target.value;
    if (!regex.test(searchValue)) {
      this.possessionDtlUpdateService.errorToast(
        "Only English characters are Allowed."
      );
      // alert("Only English characters are Allowed.");
      if (typeof searchValue === "string") {
        searchValue = searchValue.replace(/[^a-zA-Z\s]/g, "");
        event.target.value = searchValue;
      }
    }
  }

  get DetailOfFamilyMembers() {
    return this.form.get("userResponsibilityLst")["controls"];
  }

  addFamilyMemberDetails() {
    let selectedUserResponsibilityLst: FormArray = this.form.get(
      "userResponsibilityLst"
    ) as FormArray;
    if (selectedUserResponsibilityLst.length < 10) {
      selectedUserResponsibilityLst.push(
        new FormGroup({
          key: new FormControl(null),
          memberName: new FormControl(null, Validators.required),
          memberAge: new FormControl(null, Validators.required),
          memberRelation: new FormControl(null, Validators.required),
        })
      );
    } else {
      this.possessionDtlUpdateService.errorToast("Maximum limit reached");
    }
  }

  deleteResponsibility(i: number) {
    let selectedUserResponsibilityLst: FormArray = this.form.get(
      "userResponsibilityLst"
    ) as FormArray;
    selectedUserResponsibilityLst.removeAt(i);
  }

  getUpdtFamilyMembersArray(): any[] {
    const userResponsibilityLst = this.form.get(
      "userResponsibilityLst"
    ) as FormArray;
    const familyMembersArray: any[] = [];

    if (userResponsibilityLst) {
      userResponsibilityLst.controls.forEach((control: FormGroup) => {
        const familyMember = {
          key: control.get("key").value ?? 0,
          applicationNo: this.famApplicationNo
            ? this.famApplicationNo
            : "NO UPDATE",
          memberName: control.get("memberName").value
            ? control.get("memberName").value.trim()
            : "NO UPDATE",
          memberAge: control.get("memberAge").value
            ? control.get("memberAge").value.trim()
            : "NO UPDATE",
          memberRelation: control.get("memberRelation").value
            ? control.get("memberRelation").value.trim()
            : "NO UPDATE",
        };

        familyMembersArray.push(familyMember);
      });
    }

    console.log(
      "In Method getUpdtFamilyMembersArray check familyMembersArray",
      familyMembersArray
    );
    return familyMembersArray;
  }
}
